
export const url = process.env.REACT_APP_API_URL;
// export const url = "http://localhost:8000";

//LOG IN
export const loginRoute = () =>{
  return `${url}/user/login/`
}

//USERS
export const newUserRoute = () =>{
  //return `${url}/user/create/`
  return `${url}/user`
}

export const updateUserRoute = (user_id) =>{
  //return `${url}/user/update/${user_id}`
  return `${url}/user/${user_id}`
}

export const changePasswordRoute = (user_id) =>{
  //return `${url}/user/create/`
  return `${url}/user/password/${user_id}`
}

export const usersListRoute = (status= 'all') =>{
  //return `${url}/user/list`
  if (status === 'all' || status == null) {
    return `${url}/users`
  }
  return `${url}/users/${status}`
}

export const userRoute = (user_id) =>{
  //return `${url}/user/list/${user_id}`
  return `${url}/user/${user_id}`
}

export const addRoleToUserRoute = () =>{
  //return `${url}/user/user_roles/`
  return `${url}/role/user`
}

export const deleteRoleToUserRoute = (id_role,id_user) =>{
  return `${url}/role/user/${id_role}/${id_user}`
}

export const userRolesListRoute = (user_id) =>{
  //return `${url}/user/get_roles/${user_id}`
  return `${url}/roles/user/${user_id}`
}

export const userChangeStatusRoute = (user_id) =>{
  //return `${url}/user/status/${user_id}`
  return `${url}/user/status/${user_id}`
}

export const usersByRolRoute = (id_role) =>{
  //2 Delivery
  return `${url}/users/role/${id_role}`
}


//ROLES
export const newRoleRoute = () =>{
  //return `${url}/user/roles/`
  return `${url}/role`
}

export const allActionsRoute = () =>{
  return `${url}/actions`
}

export const actionsByRolListRoute = (rol_id) =>{
  return `${url}/role/actions/${rol_id}`
}

export const addActionToRolRoute = () => {
  return `${url}/role/action`
}

export const deleteActionRolRoute = (rol_id,action_id) => {
  //return `${url}/user/get_roles/`
  return `${url}/role/action/${rol_id}/${action_id}`
}

export const rolesListRoute = () => {
  //return `${url}/user/get_roles/`
  return `${url}/roles`
}

//STORES
export const newStoreRoute = () =>{
  return `${url}/store`
}

export const storesListRoute = () =>{
  return `${url}/stores`
}

export const storeChangeStatusRoute = (user_id) =>{
  //return `${url}/user/status/${user_id}`
  return `${url}/store/status/${user_id}`
}

//COMPANIES
export const companiesListRoute = (status) =>{
  if (status === 'all' || status == null) {
    return `${url}/companies`
  }
  return `${url}/companies/${status}`
}

export const updateCompanyData = (token, payload, compnayId) =>{
  return fetch(`${url}/company/${compnayId}`, {
    method:'PATCH', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const changeStatusCompany = (token, compnayId, status) =>{
  return fetch(`${url}/company/${status}/${compnayId}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const createNewCompany = (token, payload) =>{
  return fetch(`${url}/company`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

//BOXES
export const newBoxRoute = () =>{
  return `${url}/box`
}

export const getMaxDiscountBoxRoute = (box_id) =>{
  return `${url}/box/discount/max/${box_id}`
}

export const modifyDiscountBoxRoute = (box_id) =>{
  return `${url}/box/discount/max/${box_id}`
}

export const boxesListRoute = () =>{
  return `${url}/boxes`
}

export const packageTypeListRoute = () =>{
  return `${url}/package/types`
}

export const boxPriceRoute = (id_box,id_country,company_id) =>{
  return `${url}/box/price/${id_box}/${id_country}/${company_id}`
}

export const boxPricesDetailRoute = (id_box) =>{
  return `${url}/box/price/detail/${id_box}`
}

export const newPriceBoxRoute = (id_box,id_country,id_company) =>{
  return `${url}/box/price/${id_box}/${id_country}/${id_company}`
}

export const modifyPriceBoxRoute = (id_box,id_country,id_company) =>{
  return `${url}/box/price/${id_box}/${id_country}/${id_company}`
}

//CLIENTS
export const clientByPhoneRoute = (phone) =>{
  return `${url}/client/phone/${phone}`
}

export const receiverClientsByIdSenderClient = (id_client) =>{
  return `${url}/client/deliveries/${id_client}`
}

//SEARCH
export const searchRoute = () =>{
  return `${url}/search`
}

//PLACES
export const reseiverCountriesRoute = () =>{
  return `${url}/countries`
}

export const statesRoute = (id_country) =>{
  return `${url}/delivery/state/${id_country}`
}

export const municipalitiesRoute = (id_state) =>{
  return `${url}/delivery/municipalities/${id_state}`
}

//DELIVERY

export const newDeliveryPickupRoute = () =>{
  return `${url}/delivery`
}

export const getDeliveryPickupByCorrelativeRoute = (correlative) =>{
  return `${url}/delivery/${correlative}`
}

export const modifyDeliveryPickupByCorrelativeRoute = (correlative) =>{
  return `${url}/delivery/${correlative}`
}

export const activateInactivateRoute = (box_id) =>{
  return `${url}/delivery/activation/${box_id}`
}

export const balancePaymentRoute = (box_id) =>{
  return `${url}/box/toggle/balancepayment/${box_id}`
}

export const boxClosureRoute = (box_id) =>{
  return `${url}/closure/box/${box_id}`
}

export const getBoxesByDateRoute = (date) =>{
  return `${url}/boxes/${date}`
}

export const getBoxAuditRoute = (box_id) =>{
  return `${url}/box/audit/${box_id}`
}

//ROUTES EEUU

export const originCountryRoutesRoute = () =>{
  return `${url}/countryroute`
}

export const newOriginCountryRoute = () =>{
  return `${url}/countryroute`
}

export const updateOrignCountryRoute = (token, payload, routeId) =>{
  return fetch(`${url}/countryroute/${routeId}`, {
    method:'PATCH', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const originCountryRouteDetail = (id_route) =>{
  return `${url}/countryroute/detail/${id_route}`
}

export const newOriginCountryRouteZIP = () =>{
  return `${url}/countryroute/detail`
}

export const deleteZipRouteRoute = (id_route,zip) =>{
  return `${url}/countryroute/detail/${id_route}/${zip}`
}

export const getRouteByZip = (zip) =>{
  return `${url}/countryroute/zip/${zip}`
}

export const changeBoxRouteRoute = (id_box) =>{
  return `${url}/box/route/${id_box}`
}

//ROUTES EEUU (ASIGNACION)

//asignar driver a una ruta
export const driverRouteAssignmentRoute = () =>{
  return `${url}/driver/route`
}

//obterner nombre driver asignado
export const getDriverRouteAssignmentRoute = (route_id,assignment_date) =>{
  return `${url}/driver/route/${route_id}/${assignment_date}`
}

//obtener detalle de la ruta 
export const getDriverRouteDetail = (route_id,assignment_date) =>{
  return `${url}/driver/detail/${route_id}/${assignment_date}`
}


//INGRESO DE EFECTIVO
export const getBoxPaymentsSummaryRoute = (id_box) =>{
  return `${url}/payment/summary/${id_box}`
}

export const getBoxPaymentsHistoryRoute = (id_box) =>{
  return `${url}/payment/${id_box}`
}

export const getBoxPaymentsDetailRoute = (id_box) =>{
  return `${url}/payment/detail/${id_box}`
}

export const newPaymentRoute = () =>{
  return `${url}/payment`
}

export const deletePaymentRoute = (id_payment) =>{
  return `${url}/payment/${id_payment}`
}


//CONTENEDORES (CARGA)

export const newContainerRoute = () =>{
  return `${url}/container`
}

export const newContainerBoxRoute = () =>{
  return `${url}/container/box`
}

export const getContainerStatusRoute = () =>{
  return `${url}/containers/status`
}

export const getContainerByCodeRoute = (container_code) =>{
  return `${url}/container/${container_code}`
}

export const getContainerByIdRoute = (id) =>{
  return `${url}/container/id/${id}`
}

export const getContainerDetailsRoute = (id) =>{
  return `${url}/container/details/${id}`
}

export const modifyContainerStatusRoute = (id) =>{
  return `${url}/container/status/${id}`
}

export const modifyContainerRoute = (containier_id) =>{
  return `${url}/container/${containier_id}`
}

export const getContainersRoute = () =>{
  return `${url}/containers`
}

export const getContainersByDateRoute = (initial_date,final_date) =>{
  return `${url}/containers/date/${initial_date}/${final_date}`
}

export const deleteBoxContainerRoute = (id_container,id_box) =>{
  return `${url}/container/${id_container}/${id_box}`
}

// CIERRE DE RUTA DELIVERY
export const getClosureDelivery = (date,user_driver) =>{
  return `${url}/route/closure/delivery/${date}/${user_driver}`
}

// CIERRE DE RUTA PICKUP
export const getClosurePickup = (date,user_driver) =>{
  return `${url}/route/closure/pickup/${date}/${user_driver}`
}

// GASTOS DE RUTALL
/*export const getExpensesDateDriver = (date, user_driver) => {
  return `${url}/expenses/${user_driver}/${date}`
}*/
export const getExpensesDateDriver = (token, date, user_driver) => {
  return fetch(`${url}/expenses/${user_driver}/${date}`, {
    method:'GET', headers:defaultHeadersWithToken(token)
  });
}

export const updateExpensesById = (token, payload, id) =>{
  return fetch(`${url}/expense/${id}`, {
    method:'PUT', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const deleteExpenseById = (id, token) =>{
  return fetch(`${url}/expense/${id}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}


// REPORTE DE CAJAS POR DRIVER
export const getDriverBoxesReport = (type, user_driver, init_date, end_date) => {
  return `${url}/report/${type}/boxesdriver/${user_driver}/${init_date}/${end_date}`
}

// REPORTE DE CONTRATOS
export const getContractsReportRoute = (filter, container_id) => {
  return `${url}/report/contracts/${filter}/container/${container_id}`
}

// REPORTE DE CARGA
export const getContainerReportRoute = (filter, container_id) => {
  return `${url}/report/containers/${filter}/container/${container_id}`
}

// REPORTE DE TIPO DE PAGO
export const getPaymentTypeReportRoute = (init_date, end_date) => {
  return `${url}/report/paymenttype/${init_date}/${end_date}`
}

// REPORTE DE PICKUPS DE USUARIOS
export const getUserPickupsReportRoute = (init_date, end_date) => {
  return `${url}/report/userpickups/insurance/${init_date}/${end_date}`
}

// REPORTE DE INGRESO DE EFECTIVO
export const getCashIncomeReportRoute = (user,init_date,end_date) => {
  return `${url}/report/cashincome/${user}/${init_date}/${end_date}`
}

// REPORTE DE CUADRE
export const getCashBalanceReportRoute = (user_driver,receiving_user,init_date,end_date) => {
  return `${url}/report/balance/${user_driver}/${receiving_user}/${init_date}/${end_date}`
}

// REPORTE DE STICKER POR DRIVER
export const getStickersReportRoute = (user_driver, init_date, end_date) => {
  return `${url}/report/stickers/${user_driver}/${init_date}/${end_date}`
}

// REPORTE DE VENTAS POR EMPRESA
export const salesFiltersRoute = () => `${url}/report/sales-filters`

const buildSalesParams = (params) => {
  const queryParams = new URLSearchParams();
  queryParams.append('init_date', params.init_date);
  queryParams.append('end_date', params.end_date);
  (params.companies || []).forEach((id) => queryParams.append('companies', id));
  (params.countries || []).forEach((id) => queryParams.append('countries', id));
  (params.states || []).forEach((s) => queryParams.append('states', s));
  (params.cities || []).forEach((c) => queryParams.append('cities', c));
  if (params.record_status) queryParams.append('record_status', params.record_status);
  return queryParams;
}

export const getSalesByCompanyReportRoute = (params) => {
  const queryParams = buildSalesParams(params);
  if (params.group_by) queryParams.append('group_by', params.group_by);
  return `${url}/report/sales-by-company?${queryParams.toString()}`
}

export const getSalesOrdersRoute = (params) => {
  const queryParams = buildSalesParams(params);
  queryParams.append('page', params.page || 1);
  queryParams.append('page_size', 25);
  return `${url}/report/sales-orders?${queryParams.toString()}`
}

//GASTOS
export const newFeeRoute = () =>{
  return `${url}/expense`
}

//CIERRE DE RUTAS (CUADRE)
export const getCahsBalanceDriversRoute = () =>{
  return `${url}/balance`
}

export const getHistoryCashRoute = () =>{
  return `${url}/balance/history`
}

export const getCashBalanceByUser = (token, driver_id, date) => {
  const queryParams = new URLSearchParams({driver_id, date}).toString();
  return fetch(`${url}/balance/by-user?${queryParams}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}` }
  });
}

export const createCashEntry = (token, payload) => {
  return fetch(`${url}/balance`, {
    method:'POST',
    headers:{      "Authorization":`Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept":"application/json",
    },
    body:JSON.stringify(payload)
  });
}


export const newCashDriverRoute = () =>{
  return `${url}/balance`
}

//PERMISOS
export const getPermissionsRoute = (user_id) =>{
  return `${url}/user/permissions/${user_id}`
}

//CAJAS CON SALDO
export const getBalanceBoxesRoute = () =>{
  return `${url}/balance/boxes`
}

//TRACKING
export const getTrackingBoxeRoute = (box_id) =>{
  return `${url}/box/tracking/${box_id}`
}

//TRACKING
export const sendSMSRoute = (type) =>{
  return `${url}/sms/boxes/${type}`
}


//NUEVAS RUTAS

//ETIQUETA INDIVIDUAL
export const getStickerDataRoute = (box_id) =>{
  return `${url}/report/sticker/${box_id}`
}

// REPORTE DE STICKER POR DRIVER
export const getAllStickersDataRoute = (user_driver, init_date, end_date) => {
  return `${url}/report/stickers/${user_driver}/${init_date}/${end_date}`
}

//CONTRATO INDIVIDUAL
export const getContractDataRoute = (box_id) =>{
  return `${url}/report/contract/${box_id}`
}

//REPORTE DE CONTRATOS
export const getAllContractsDataRoute = (filter, container_id) => {
  return `${url}/report/contracts/${filter}/container/${container_id}`
}

//RECIBO DE CONTRATOS
export const getReceipDataRoute = (payment_id) => {
  return `${url}/report/receipt/${payment_id}`
}

// ESTADOS DE CAJAS
export const getBoxStatus = (token) => {
  return fetch(`${url}/box/status`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  });
}

// ESTADOS DE CAJAS
export const updateBoxStatus = (token, boxId, newBoxStatus) => {
  const payload = { boxId, status: newBoxStatus };
  return fetch(`${url}/box/change-status`, {
    method:'PUT', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

// CIERRE PICKUP
export const getClosureSummaryForPickup = (token, from_date, end_date) => {
  const queryParams = new URLSearchParams({from_date, end_date}).toString();
  return fetch(`${url}/closure/pickup-summary?${queryParams}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  })
}

// CIERRE DELIVERY
export const getClosureSummaryForDelivery = (token, from_date, end_date) => {
  const queryParams = new URLSearchParams({from_date, end_date}).toString();
  return fetch(`${url}/closure/delivery-summary?${queryParams}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  })
}

// CIERRE GASTOS
export const getClosureFeesSummary = (token, from_date, end_date) => {
  const queryParams = new URLSearchParams({from_date, end_date}).toString();
  return fetch(`${url}/closure/fees-summary?${queryParams}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  })
}

// CIERRE RECEPCIÓN DE EFECTIVO
export const getClosureCashReceptionSummary = (token, from_date, end_date) => {
  const queryParams = new URLSearchParams({from_date, end_date}).toString();
  return fetch(`${url}/closure/cash-reception-summary?${queryParams}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  })
}

//user-companies
export const userCompanyListRoute = (user_id) =>{
  return `${url}/user-company/by/${user_id}`
}

export const addCompanyToUserRoute = (token, payload) =>{
  return fetch(`${url}/user-company`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const reassignmetRegister = (token, payload) =>{
  return fetch(`${url}/reassignment`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const reportarNoVisita = (token, id_box, reason) =>{
  return fetch(`${url}/reassignment/report`, {
    method:'POST', headers:defaultHeadersWithToken(token),
    body:JSON.stringify({ id_box, reason })
  });
}

export const getReassignatioHistory = (token, id_box) => {
  return fetch(`${url}/reassignments/history/by/${id_box}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  });
}

export const getImagesByBoxId = (token, id_box) => {
  return fetch(`${url}/box-image/images/by/${id_box}`, {
    method:'GET', headers:{Authorization:`Bearer ${token}`}
  });
}

export const deleteCompanyToUserRoute = (id_compnay, id_user, token) =>{
  return fetch(`${url}/user-company/delete/${id_user}/${id_compnay}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const customerChannelList = () =>{
  return `${url}/customer-channel/list`
}

export const updateCommunicationChannel = (token, payload, id) =>{
  return fetch(`${url}/customer-channel/${id}`, {
    method:'PUT', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const creteCommunicationChannel = (token, payload) =>{
  return fetch(`${url}/customer-channel`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const saveBoxImage = (token, payload, boxId) =>{
  return fetch(`${url}/box-image/box/${boxId}`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

export const deleteBoxImage = (token, id_image) => {
  return fetch(`${url}/box-image/delete/${id_image}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const deleteDriverFromRoute = (route_id, driver_id, date, token) =>{
  return fetch(`${url}/driver/remove/by/${route_id}/${driver_id}/${date}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const reassignRoutingOfMultipleBoxes = (token, payload) =>{
  return fetch(`${url}/boxes/routes/reassignment`, {
    method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload)
  });
}

//RUTEO AUTOMATICO
export const automaticRoutesListRoute = (status, creation_date) => {
  const queryParams = new URLSearchParams({ status });
  if (creation_date) queryParams.append('creation_date', creation_date);
  return `${url}/ruteo/routes?${queryParams.toString()}`
}

export const ruteoDriversListRoute = (creation_date) => {
  const queryParams = creation_date ? `?${new URLSearchParams({ creation_date }).toString()}` : '';
  return `${url}/ruteo/drivers${queryParams}`
}

export const buildAutomaticRoutes = (token, create_user, target_date) => {
  const queryParams = new URLSearchParams({ create_user, target_date }).toString();
  return fetch(`${url}/ruteo/build-routes?${queryParams}`, {
    method:'POST', headers:defaultHeadersWithToken(token),
  });
}

export const removeOrderFromRoute = (token, route_id, box_id) => {
  return fetch(`${url}/ruteo/routes/${route_id}/remove-order/${box_id}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const optimizeRoute = (token, route_id) => {
  return fetch(`${url}/ruteo/routes/${route_id}/optimize`, {
    method:'PUT', headers:defaultHeadersWithToken(token),
  });
}

export const moveOrderToRoute = (token, route_id, box_id, target_route_id) => {
  const queryParams = new URLSearchParams({ box_id, target_route_id }).toString();
  return fetch(`${url}/ruteo/routes/${route_id}/move-order?${queryParams}`, {
    method:'PUT', headers:defaultHeadersWithToken(token),
  });
}

export const addOrderToRoute = (token, route_id, box_id) => {
  return fetch(`${url}/ruteo/routes/${route_id}/add-order/${box_id}`, {
    method:'POST', headers:defaultHeadersWithToken(token),
  });
}

export const createEmptyRoute = (token, base_origin, creation_date) => {
  const queryParams = new URLSearchParams({ base_origin, creation_date }).toString();
  return fetch(`${url}/ruteo/routes/create-empty?${queryParams}`, {
    method:'POST', headers:defaultHeadersWithToken(token),
  });
}

export const approveRoute = (token, route_id, driver_id) => {
  const queryParams = new URLSearchParams({ driver_id }).toString();
  return fetch(`${url}/ruteo/routes/${route_id}/approve?${queryParams}`, {
    method:'PUT', headers:defaultHeadersWithToken(token),
  });
}

export const rejectRoute = (token, route_id) => {
  return fetch(`${url}/ruteo/routes/${route_id}`, {
    method:'DELETE', headers:defaultHeadersWithToken(token),
  });
}

export const anillosListRoute = () => `${url}/ruteo/anillos`
export const anilloCiudadesRoute = (ring_id) => `${url}/ruteo/anillos/${ring_id}/ciudades`
export const sinAnilloRoute = (fecha) => `${url}/ruteo/anillos/sin-anillo?fecha=${fecha}`

export const createAnillo = (token, payload) =>
  fetch(`${url}/ruteo/anillos`, { method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload) })

export const updateAnillo = (token, ring_id, payload) =>
  fetch(`${url}/ruteo/anillos/${ring_id}`, { method:'PUT', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload) })

export const addCiudadToAnillo = (token, ring_id, payload) =>
  fetch(`${url}/ruteo/anillos/${ring_id}/ciudades`, { method:'POST', headers:defaultHeadersWithToken(token), body:JSON.stringify(payload) })

export const deleteCiudadFromAnillo = (token, ring_id, zip_code) =>
  fetch(`${url}/ruteo/anillos/${ring_id}/ciudades/${zip_code}`, { method:'DELETE', headers:defaultHeadersWithToken(token) })

const defaultHeadersWithToken = (token) => {
  return {
    "Content-Type": "application/json",
    "Accept":"application/json",
    "Authorization": `Bearer ${token}`
}
}


export default url;
